<template>
  <div v-loading="loading" class="guild_main">
    <div class="guild_color">
      <div class="guild_title fc-flex-vcenter fc-wrap">
        <div class="guild_font fc-mar-r-sm">
          {{ model.guildName }}
        </div>
        <div class="fc-flex fc-flex-vcenter">
          <span class="fc-mar-r-min guild_font">{{$t('m.agency_ID',{'msg_ss':+model.guildId})}}</span>
          <el-button
            type="primary"
            size="mini"
            round
            v-clipboard:copy="copyTxt(model.guildId)"
            v-clipboard:success="onCopy"
            v-clipboard:error="onError"
            style="padding: 0 10px; height: 24px"
            >{{$t('m.copy')}}</el-button
          >
        </div>
      </div>
      <div class="fc-flex fc-flex-vcenter">
        <div>{{$t('m.invite_live_join')}}: </div>
        <div style="margin-right: 5px">{{ model.shortUrl }}</div>
        <el-button
          type="primary"
          size="small"
          round
          v-clipboard:copy="copyTxt(model.shortUrl)"
          v-clipboard:success="onCopy"
          v-clipboard:error="onError"
          style="padding: 0 10px; height: 24px"
          >{{$t('m.copy')}}</el-button
        >
      </div>
      <div class="fc-flex fc-flex-vcenter" style="margin-top: 10px;">
        <div style="margin-right: 5px">{{$t('m.invite_guild_url',{'msg_ss':inviteUrl})}} </div>
        <el-button
          type="primary"
          size="small"
          round
          v-clipboard:copy="copyTxt(inviteUrl)"
          v-clipboard:success="onCopy"
          v-clipboard:error="onError"
          style="padding: 0 10px; height: 24px"
          >
          {{$t('m.copy')}}
        </el-button>
        <el-button
          type="primary"
          size="small"
          round
          v-clipboard:copy="copyTxt($t('m.invite_guild_code', { 'msg_ss': model.inviteCode}))"
          v-clipboard:success="onCopy"
          v-clipboard:error="onError"
          style="padding: 0 10px; height: 24px"
          >
          {{ $t('m.invite_guild_code', { 'msg_ss': model.inviteCode})}}
        </el-button>
      </div>
    </div>
    <div class="guild_color guild_margin guildForm">
      <el-row :gutter="10" class="guild_title">
        <el-col>
          <span class="decorate_line"></span>&nbsp;&nbsp;
          <span style="font-size: 16px; font-weight: 500">{{$t('m.base_info')}}</span>
          <span style="font-size: 12px;">{{$t('m.note')}}</span>
          <!--修改-->
          <!-- <img src="../../assets/img/square_check.png" v-if="setState" @click="editDetailDebounce">
          <img src="../../assets/img/edit.png" v-else @click="doEdit"> -->
          <el-button type="primary" size="mini" v-if="setState" @click="editDetailDebounce">{{ $t('m.save') }}</el-button>
          <el-button type="primary" size="mini" v-else @click="doEdit">{{ $t('m.compile') }}</el-button>
          <!--修改记录-->
          <el-button type="text" @click="getEditLog">{{$t('m.edit_log')}}</el-button>
        </el-col>
      </el-row>
      <el-form size="mini" :model="model" :rules="rules" label-width="120px" ref="createForm" v-loading="editLoading">
        <el-row :gutter="10" class="guild_title">
          <el-col :xl="8" :lg="8" :md="12" :sm="12" :xs="24">
            <div style="display: flex; flex-wrap: wrap" class="guild_col">
              <div>{{$t('m.agency_logo')}}: </div>
              <div v-if="model.guildLogo">
                <img
                  :src="model.guildLogo"
                  @click="showPicPreviewDialog(model.guildLogo)"
                  class="img-thumb"
                />
              </div>
              <el-upload
                v-if="setState"
                class="avatar-uploader"
                :class="{ hideUploadBtn: guildLogoArr.length > 0 }"
                :action="uploadAction"
                list-type="picture"
                :multiple="false"
                :on-remove="removeLogoUpload"
                :on-success="onUploadLogo"
                :on-error="onUploadError"
                :file-list="guildLogoArr"
                :before-upload="beforeLogoUpload"
                accept=".jpg,.png,.jpeg"
                :show-file-list="false"
              >
                <span style="display: inline-block; color: #008AFF ; text-decoration: underline;margin-left: 10px;">{{$t('m.edit')}}</span>
              </el-upload>
            </div>
          </el-col>
          <el-col :xl="8" :lg="8" :md="12" :sm="12" :xs="24">
            <el-form-item :label="$t('m.agency_contact_name') + ':'" prop="guildContacts" v-if="setState">
              <el-input v-model.trim="model.guildContacts" maxlength="20" :placeholder="$t('m.user_contact_name')" style="width: 200px;"></el-input>
            </el-form-item>
            <div v-else>{{$t('m.agency_contact_name')}}: {{ model.guildContacts }}</div>
          </el-col>
        </el-row>
        <el-row :gutter="10" class="guild_title">
          <el-col :xl="8" :lg="8" :md="12" :sm="12" :xs="24">
            <el-form-item :label="$t('m.agency_contact_phone') + ':'" prop="guildContactsPhone" v-if="setState">
              <div class="fc-flex fc-flex-vcenter">
                <div class="seledArea" @click.stop="showCountryFun">
                  <img class="flag_icon" :src="selCountry.logo" />
                  <span style="display: inline-block;width: 45px;" class="countrynum">+{{ selCountry.countryNum }}</span>
                  <img
                    class="select_icon"
                    :src="(showCountry && $store.state.isShowSelArea)? require('../../assets/img/icon_up.png'): require('../../assets/img/icon_down.png')"
                  />
                </div>
                <el-input v-model.trim="model.guildContactsPhone" minlength="6" @input="model.guildContactsPhone = $num(model.guildContactsPhone)" :placeholder="$t('m.agency_contact_phone')" style="width: 150px;"></el-input>
                <div class="selarea_box" v-if="showCountry && $store.state.isShowSelArea">
                  <sel-area @countryOption="countryOptionFun" />
                </div>
              </div>
            </el-form-item>
            <div class="guild_col" v-else>
              {{$t('m.agency_contact_phone')}}:
              <span class="direction_ltr">{{model.guildContactsAreaCode?'+'+model.guildContactsAreaCode:''}}{{ model.guildContactsPhone }}</span>
            </div>
          </el-col>
          <el-col :xl="8" :lg="8" :md="12" :sm="12" :xs="24">
            <el-form-item :label="$t('m.agency_whatsapp') + ':'" prop="guildAdminWhatsApp" v-if="setState">
              <el-input v-model.trim="model.guildAdminWhatsApp" maxlength="50" :placeholder="$t('m.agency_whatsapp_contact')" style="width: 180px;"></el-input>
            </el-form-item>
            <div class="guild_col" v-else>
              {{$t('m.agency_whatsapp')}}: {{ model.guildAdminWhatsApp }}
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="10" class="guild_title">
          <el-col :xl="8" :lg="8" :md="12" :sm="12" :xs="24">
            <el-form-item :label="$t('m.agency_use_lang') + ':'" prop="guildAdminUserLang" v-if="setState">
              <el-select v-model="model.guildAdminUserLangToArr" :placeholder="$t('m.select')" filterable multiple style="width: 200px;">
                <el-option v-for="item in guildAdminUserLangArr" :key="item.key" :label="item.name" :value="item.key">
                </el-option>
              </el-select>
            </el-form-item>
            <div class="guild_col" v-else>
              {{$t('m.agency_use_lang')}}: {{model.guildAdminUserLang|filtersLangArr}}
            </div>
          </el-col>
          <el-col :xl="8" :lg="8" :md="12" :sm="12" :xs="24">
            <!-- <el-form-item :label="$t('m.agency_head_ID') + ':'" prop="guildAdminId" v-if="setState">
              <el-input v-model.trim="model.guildAdminId" maxlength="10" :placeholder="$t('m.agency_ID_input')" oninput="value=value.replace(/[^\d]/g,'')" style="width: 200px;"></el-input>
              <span class="el-form-item__error" v-if="guildAdminNickname" style="margin: 0">{{$t('m.nickname')}} 【{{ guildAdminNickname }}】</span>
              <i class="el-icon-loading el-form-item__error" v-if="getnameloading"></i>
            </el-form-item> -->
            <div class="guild_col">{{$t('m.agency_head_ID')}}: {{ model.guildAdminId }}
              <i class="el-icon-link" style="cursor: pointer;" @click="changeGuildAdminId"></i>
            </div>
          </el-col>
        </el-row>

        <el-row :gutter="10" class="guild_title">
          <el-col :xl="8" :lg="8" :md="12" :sm="12" :xs="24">
            <div>{{$t('m.reg_country')}}: {{ computedCount(model.phoneCountry) }}</div>
          </el-col>
          <el-col :xl="8" :lg="8" :md="12" :sm="12" :xs="24">
            <div style="display: flex; flex-wrap: wrap" class="guild_col">
              <div>{{$t('m.inhand_ID_photo')}}: </div>
              <div v-if="model.guildAdminCardJustPic">
                <img
                  :src="model.guildAdminCardJustPic"
                  @click="showPicPreviewDialog(model.guildAdminCardJustPic)"
                  class="img-thumb"
                />
              </div>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="10" class="guild_title">
          <el-col :xl="8" :lg="8" :md="12" :sm="12" :xs="24">
            <el-form-item :label="$t('m.mian_form_country') + ':'" prop="anchorCountry" v-if="setState">
              <el-select v-model="model.anchorCountryToArr" :placeholder="$t('m.select')" filterable multiple style="width: 200px;">
                <el-option v-for="item in anchorCountryArr" :key="item.coding+item.id" :label="item.content" :value="item.coding">
                </el-option>
              </el-select>
            </el-form-item>
            <div v-else>{{$t('m.mian_form_country')}}:{{ computedCount(model.anchorCountry) }}</div>
          </el-col>
          <el-col :xl="8" :lg="8" :md="12" :sm="12" :xs="24">
            <div>{{$t('m.invite_code')}}: {{ model.superInviteCode }}</div>
          </el-col>
        </el-row>
        <el-row :gutter="10" class="guild_title">
          <el-col :xl="8" :lg="8" :md="12" :sm="12" :xs="24">
            <div>{{$t('m.apply_time')}}: {{ model.applyTime }}</div>
          </el-col>
          <el-col :xl="8" :lg="8" :md="12" :sm="12" :xs="24">
            <div>{{$t('m.join_time')}}: {{ model.approveTime }}</div>
          </el-col>
        </el-row>
        <el-row :gutter="10" class="guild_title">
          <el-col :xl="8" :lg="8" :md="12" :sm="12" :xs="24">
            <div v-if="model.cooperationState == 1">
              <!-- {{$t('m.cooper_status')}}: {{
                model.cooperationState == 0
                  ? "未合作"
                  : model.cooperationState == 1
                  ? $t('m.cooper_ing')
                  : "终止合作"
              }} -->
              {{$t('m.cooper_status')}}:{{$t('m.cooper_ing')}}
            </div>
          </el-col>
          <el-col :xl="8" :lg="8" :md="12" :sm="12" :xs="24">
            <el-form-item :label="$t('m.email') + ':'" prop="email" v-if="setState">
              <el-input v-model.trim="model.email" maxlength="50" :placeholder="$t('m.email')" style="width: 180px;"></el-input>
            </el-form-item>
            <div class="guild_col" v-else>
              {{$t('m.email')}}: {{ model.email }}
            </div>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <!--基本信息修改变更记录弹框-->
    <el-dialog :title="$t('m.edit_log')" :visible.sync="dialogTableVisible" :close="closeLogDialog">
      <el-table :data="tableData" v-loading="tableLoading" border>
        <el-table-column property="createTime" :label="$t('m.edit_time')" :fixed="$store.state.localeLang=='ar'?false:true"></el-table-column>
        <el-table-column property="guildName" :label="$t('m.agency_name')" :fixed="$store.state.localeLang=='ar'?false:true"></el-table-column>
        <el-table-column property="guildLogo" :label="$t('m.agency_logo')"></el-table-column>
        <el-table-column property="guildContacts" :label="$t('m.agency_contact_name')"></el-table-column>
        <el-table-column property="guildContactsPhone" :label="$t('m.agency_contact_phone')"></el-table-column>
        <el-table-column property="guildAdminWhatsApp" :label="$t('m.agency_whatsapp')"></el-table-column>
        <el-table-column property="guildAdminUserLang" :label="$t('m.agency_use_lang')">
          <template slot-scope="scope">
            {{scope.row.guildAdminUserLang|filtersLangArr}}
          </template>
        </el-table-column>
        <el-table-column property="guildAdminId" :label="$t('m.agency_head_ID')"></el-table-column>
        <el-table-column property="anchorCountry" :label="$t('m.mian_form_country')">
          <template slot-scope="scope">
            {{ computedCount(scope.row.anchorCountry) }}
          </template>
        </el-table-column>
        <el-table-column property="email" :label="$t('m.email')"></el-table-column>
      </el-table>
    </el-dialog>

    <el-dialog
      :visible.sync="dialog.show"
      :title="$t('m.preview')"
      :append-to-body="true"
    >
      <img :src="dialog.picSrc" class="img-preview" />
    </el-dialog>
    <el-dialog
      :visible.sync="dialog.picture.show"
      :title="$t('m.preview')+':'"
      @close="resetInfoForm"
      :append-to-body="true"
    >
      <div v-loading="dialog.picture.loading">
        <el-carousel :autoplay="false" indicator-position="none" arrow="always">
          <el-carousel-item
            v-for="(item, index) in dialog.picture.fileList"
            :key="index"
          >
            <img :src="item" class="img-preview" />
          </el-carousel-item>
        </el-carousel>
      </div>
    </el-dialog>
    <ChangeGuildAdminDialog ref="refChangeGuildAdminDialog" @success="changeSuccess"/>

  </div>
</template>

<script>
import {editDetailInfo, getEditLogList, getMyGuildDetail} from "../../api/guild/my-guild-detail";
import {anchorCountryArrAjax, getCountryMsg} from "../../api/common";
import {isEmailValidPattern, mobileValid} from "../../utils/coding-utils";
import {userLangArr} from "../../utils/common";
import SelArea from "../../components/SelArea";
import {getGuildAdminCheckUser} from "../../api/apply/index";
import ChangeGuildAdminDialog from "./components/changeGuildAdminDialog.vue";

export default {
  name: "my-guild-detail-page",
  components: {
    "sel-area": SelArea,
    ChangeGuildAdminDialog
  },
  inject:['reload'],
  data() {
    const token = this.$store.state.userInfo.token;
    return {
      confirmLoading: false,
      editLoading: false,
      dialogTableVisible: false,
      tableLoading: false,
      tableData: [],
      loading: false,
      setState: false,
      validState: false,
      showCountry: false,
      selCountry: {},
      guildAdminNickname: "",
      phoneCountry:null,
      getnameloading: false,
      uploadAction:
        this.global_huanjing.uploadApi +
        "?token=" +token +
        "&flag=5" +
        "&temp=" +new Date().getTime(),
      guildLogoArr:[],
      guildAdminUserLangArr: userLangArr,
      anchorCountryArr: [],
      rules: {
        // guildLogo: [
        //   { required: true, trigger: "change", message: this.$t('m.no_data') }
        // ],
        guildContacts: [
          { required: true, trigger: "change", message: this.$t('m.no_data') }
        ],
        email: [
          { required: true, trigger: "change", message: this.$t('m.no_data') },
          { pattern: isEmailValidPattern(), message: this.$t('m.email_check') },
        ],
        guildContactsPhone: [
          { required: true, trigger: "change", message: this.$t('m.no_data') },
          { pattern: mobileValid(), message: this.$t('m.check_phone_istrue') },
        ],
        guildAdminWhatsApp: [
          { required: true, trigger: "change", message: this.$t('m.agency_whatsapp_contact') }
        ],
        guildAdminUserLang: [
          { required: true, trigger: "change", message: this.$t('m.no_data') }
        ],
        guildAdminId: [
          { required: true, trigger: "change", message: this.$t('m.no_data') },
          { validator: this.validatorDuration, trigger: "blur" },
        ],
        anchorCountry: [
          { required: true, trigger: "change", message: this.$t('m.no_data') }
        ],
      },
      model: {
        guildLogo: null,
        guildContacts: null,
        guildContactsPhone: null,
        guildAdminWhatsApp: null,
        guildAdminUserLang: null,
        guildAdminUserLangToArr: [],
        guildAdminId: null,
        anchorCountry: null,
        anchorCountryToArr:[],
        email: null
      },
      lang:'zh,ar',
      dialog: {
        picSrc: null,
        show: false,
        picture: {
          show: false,
          fileList: [],
        },
      },
      countryArr: null,
      inviteUrl: '',
    };
  },
  computed:{
    computedCount(){
      return(val) => {
        if(!val){
          return '';
        }else if(!this.countryArr){
          return val;
        }else{
          let oldArr=val.split(',');
          let newCountry='';
          oldArr.forEach((e,index) => {
            for(let i=0;i<this.countryArr.length;i++){
              if(e==this.countryArr[i].coding){
                if(index<1){
                  newCountry+=this.countryArr[i].content
                }else{
                  newCountry+=(','+this.countryArr[i].content)
                }
              }
            }
          });
          return newCountry;
        }

      }

    }
  },
  // watch: {
  //   'model.guildAdminId':{
  //     handler(val){
  //       if(!val){
  //         this.guildAdminNickname=null;
  //         this.model.phoneCountry=null;
  //       }
  //     }
  //   }
  // },
  methods: {
    changeSuccess(id) {
      this.model.guildAdminId = id;
    },
    changeGuildAdminId() {
      this.$refs.refChangeGuildAdminDialog.showDialog(this.model);
    },
    /**
     * 获取修改记录
     */
    getEditLog() {
      this.tableData = []
      this.dialogTableVisible = true
      this.tableLoading = true
      getEditLogList().then(({data}) => {
        this.tableData = data.data.list
      }).catch(() => {
      }).finally(() => {
        this.tableLoading = false
      })
    },
    /**
     * 关闭弹窗
     */
    closeLogDialog() {
      this.tableData = []
      this.dialogTableVisible = false
      this.tableLoading = false
    },

    async validatorDuration(rules, value, callback) {
      if(this.validState) {
        return false;
      }
      if(this.getnameloading) {
        return;
      }
      this.getnameloading = true;
      this.guildAdminNickname = null
      if (value) {
        let detail = await this.getGuildAdminNickname();
        console.log('detail--'+JSON.stringify(detail))
        this.getnameloading = false;
        this.guildAdminNickname = null;
        if (!detail) {
          // callback(new Error(this.$t('m.user_not_exist')));
          return false;
        } else if (detail.state === 2) {
          // 用户被临时冻结
          callback(new Error(this.$t('m.user_not_exist')));
          return false;
        } else if (detail.state === 3) {
          callback(new Error(this.$t('m.user_frozen')));
          return false;
        }  else if (detail.state === 4) {
          callback(new Error(this.$t('m.apply_anchor_error')));
          return false;
        }  else if (detail.state === 5) {
          callback(new Error(this.$t('m.sign_anchor_error')));
          return false;
        }  else if (detail.state === 1) {
          callback(new Error(this.$t('m.bc_user_id_error')));
          return false;
        } else if(detail.state === 0) {
          this.guildAdminNickname = detail.nickName;
          this.model.phoneCountry=detail.phoneCountry;
          callback();
        }else {
          callback(new Error(this.$t('m.user_not_exist')));
          return false;
        }
      }
    },

    getGuildAdminNickname() {
      if (!this.model.guildAdminId) {
        this.guildAdminNickname = "";
        return false;
      }
      return new Promise((resolve, reject) => {
        getGuildAdminCheckUser(this.model.guildAdminId)
          .then(({ data }) => {
            resolve(data.data);
          })
          .catch((error) => {
            this.btnLoading = false;
            this.$message.error(this.$t('m.network_busy'));
            resolve('');
          });
      });
    },
    // 显示区号？
    showCountryFun(){
      console.log(111);
      if(this.showCountry && this.$store.state.isShowSelArea){
        this.showCountry = false;
        this.$store.state.isShowSelArea = false;
      }else{
        this.$store.state.isShowSelArea=true;
        this.showCountry = true;
      }
    },
    //获取默认区号
    getCountryMsgFun(){
      if(this.selCountry.countryNum) return false;
      getCountryMsg().then(({data}) =>{
        this.selCountry=data.result;
        console.log(this.selCountry);
      })
    },
    // 选择区号
    countryOptionFun(val) {
      this.selCountry = val;
      this.showCountry = false;
    },
    // 获取国家列表
    countryArrFun(){
      if(this.$store.state.countryArr){
        this.countryArr=this.$store.state.countryArr;

      }else{
        // anchorCountryArrAjax()
        // .then(({ data }) => {
        //   this.countryArr=data.data;
        // })
        this.countryArr = this.anchorCountryArr;
      }
    },
    getAllCountry() {
      anchorCountryArrAjax()
      .then(({ data }) => {
        this.anchorCountryArr=data.data;
        this.countryArrFun();
      })
    },
    // 复制
    copyTxt(txt){
      return txt+'';
    },
    // 复制成功
    onCopy (e) {
      this.$message.success(this.$t('m.copy_success'));
    },
    // 复制失败
    onError (e) {
      console.log(e);
      this.$message.error(this.$t('m.oper_failed'));
    },
    // 图片预览
    showPicPreviewDialog(imgUrl) {
      this.dialog.picSrc = imgUrl;
      this.dialog.show = true;
    },
    // 关闭图片预览
    resetInfoForm() {
      this.dialog.picture.fileList = [];
    },
    doEdit() {
      if(this.model.guildAdminUserLang) {
         this.model.guildAdminUserLangToArr = this.model.guildAdminUserLang.split(',');
      }
      /*
      anchorCountryToArr
      */
      if(this.model.anchorCountry) {
        this.model.anchorCountryToArr = this.model.anchorCountry.split(',');
      }
      if(this.model.guildContactsAreaCode) {
        var items = this.anchorCountryArr.find(item => item.countryNum == this.model.guildContactsAreaCode);
        console.log(this.model.guildContactsAreaCode);
        console.log(items);
        if(items) {
          this.selCountry.logo = items.logo;
          this.selCountry.countryNum = items.countryNum;
        }
      }
     this.setState = true;
    },

    editDetailDebounce: _.debounce(function() {
    this.editDetail()
    }, 500),

    editDetail() {
      if(this.editLoading) {
        return
      }
      this.$refs.createForm.validate(valid => {
        this.validState = false;
        if (valid) {
          this.editLoading = true
          // if(this.model.guildAdminId > 2147483647) {
          //   this.editLoading = false
          //   return false;
          // }
          this.model.guildContactsAreaCode = this.selCountry.countryNum;
          this.model.guildAdminUserLang = this.model.guildAdminUserLangToArr.toString();
          this.model.anchorCountry = this.model.anchorCountryToArr.toString();
          editDetailInfo(this.model)
          .then(({data}) => {
            this.setState = false;
            this.getDetail();
          })
          .catch(error => {}).finally(() => {this.editLoading = false})
        }else {
          this.validState = true;
          return false;
        }
      })
    },
    // 获取公会详情
    getDetail() {
      let _self=this;
      this.loading = true;
      getMyGuildDetail()
        .then(({ data }) => {
          if (data.data) {
            // 获取当前的域名
            const host = window.location.host
            // 如果菲律宾专属域名，需要将shortUrl中的域名替换为sharing.buzzcast.buzz, 并且在链接后加上参数from=1,表示公会分享，用户访问时，直接重定向到菲律宾专属域名
            if(host === 'guild.buzzcast.buzz') {
              if(data.data.shortUrl) {
                //获取shortUrl链接中的域名，并替换为sharing.buzzcast.buzz
                let hostname = data.data.shortUrl.match(/^(https?:\/\/)?([^\/]+)/i)
                // 0：匹配到的完整字符串，1：匹配到的域名前面的协议，2：匹配到的域名
                let urlHost = hostname[2]
                data.data.shortUrl = data.data.shortUrl.replace(urlHost, 'sharing.buzzcast.buzz')
                // 判断链接后是否已经有参数，如果没有的话，拼上?from=1, 有的话，拼上&from=1
                if(data.data.shortUrl.indexOf('?') === -1) {
                  data.data.shortUrl = data.data.shortUrl + '?from=1'
                } else {
                  data.data.shortUrl = data.data.shortUrl + '&from=1'
                }
              }
            }
            this.model = {
              ...this.model,
              ...data.data
            }
            if (this.model.inviteCode) {
              // 如果菲律宾专属域名，需要将inviteUrl中的域名替换为https://static.buzzcast.buzz
              if(host === 'guild.buzzcast.buzz') {
                this.inviteUrl = process.env.PH_H5URL + '/24perDiem/invite.html?inviteCode=' + this.model.inviteCode;
              } else {
                this.inviteUrl = process.env.H5URL + '/24perDiem/invite.html?inviteCode=' + this.model.inviteCode;
              }
            }
            // guildAdminUserLangToArr
            // anchorCountryToArr
            if(this.$route.params.first==1){
              this.$set(this.$store.state.userInfo,'guildLogo',this.model.guildLogo)
              // this.$set(this.$store.state.userInfo,'userName',this.model.userName)
              localStorage.setItem('userInfo', JSON.stringify(this.$store.state.userInfo));
            }
            if (data.data.turnoverPic) {
              let itemUrl = data.data.turnoverPic.lastIndexOf(",");
              if (itemUrl) {
                this.model.turnoverPic = data.data.turnoverPic.split(",");
              } else {
                this.model.turnoverPic = [].concat(data.data.turnoverPic);
              }
            }
            this.$store.commit("getGuildName", {
              // guildName: this.model.guildName,
              guildLogo: this.model.guildLogo
            });
          }
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
        });
    },
    //上传Logo
    onUploadError(error, file, fileList) {
      this.$message({
        type: "error",
        message: this.$t('m.img_upload_fail'),
      });
    },
    //移除文件
    removeLogoUpload(file, fileList) {
      // this.guildLogoArr = [];
      // this.model.guildLogo = null;
      return false;
    },
    onUploadLogo(response, file, fileList) {
      console.log(response);
      if (response.code && response.code !== 1) {
        // 此时虽然http的status=200, 但实际上结果为上传失败!!!
        this.$message({
          type: "error",
          message: this.$t('m.img_upload_fail')+":" + response.msg,
        });
        return;
      }
      console.log(response.result);
      this.guildLogoArr = [].concat({ url: response.result });
      this.model.guildLogo = response.result;
    },
    beforeLogoUpload(file) {
      return this.uploadLimit(file);
    },
    uploadLimit(file, hasPdf) {
      const isLt5M = file.size / 1024 / 1024 < 5;
      let isJPG = false;
      if (hasPdf) {
        if (
          file.type == "image/jpeg" ||
          file.type == "image/jpg" ||
          file.type == "image/png" ||
          file.type == "application/pdf"
        ) {
          isJPG = true;
        }
      } else {
        if (
          file.type == "image/jpeg" ||
          file.type == "image/jpg" ||
          file.type == "image/png"
        ) {
          isJPG = true;
        }
      }
      if (!isJPG) {
        this.$message.error(this.$t('m.upload_file_format_incorrect'));
        return isJPG;
      }
      if (!isLt5M) {
        this.$message.error(this.$t('m.file_is_too_large'));
        return isLt5M;
      }
      return isJPG && isLt5M;
    },
  },
  created() {
    this.getAllCountry();
    this.getCountryMsgFun();
    // this.countryArrFun();
    this.getDetail();
  },
};
</script>

<style scoped>
.decorate_line {
  display: inline-block;
  width: 5px;
  height: 12px;
  background-color: #008aff;
}
.guild_main {
  /* width: 100%; */
  /* hight: 100%; */
  color: #333333;
  /* background-color: #fff; */
  /* margin-left: 10px; */
  font-size: 14px;
  font-weight: 400;
  word-break: break-all;
}
.guild_color {
  background-color: #ffffff;
  padding: .4rem;
}
.guild_title {
  padding-bottom: 16px;
}
.guild_font {
  font-size: 22px;
  font-weight: bold;
}
.guild_margin {
  margin-top: 16px;
}
.btn_style .el-button--small {
  padding: 20px 10px;
  font-size: 20px;
}
.btn_style .el-button--info {
  color: #909399;
  background-color: #fff;
  border-color: #fff;
}
.btn_style .el-button--info:hover {
  color: #909399;
  background-color: #e0e5ee;
  border-color: #e0e5ee;
}
@media screen and (max-width: 767px) {
  .guild_col {
    padding-bottom: 16px;
  }
}
.guildForm .el-form-item{
  display: flex;
  align-items: center;
}
.guildForm .el-form-item__label{
  line-height: 1.2;
  padding-top: 7px;
}
div>>>.el-form-item__content{
  margin-left: 0 !important;
  flex: 1;
}

</style>



// WEBPACK FOOTER //
// src/pages/guild/myGuildDetailPage.vue